import { useState, useEffect } from 'react';

export const useTitsInteraction = ({ onOpen } = {}) => {
	const [connected, setConnected] = useState(false);
	const [error, setError] = useState(null); // <string | null>

	useEffect(() => {
		let shouldConnect = true;
		let socket;
		const initWebsocket = async () => {
			if (socket) {
				socket.close();
			}
			while (true) {
				if (!shouldConnect) {
					return;
				}
				try {
					socket = new WebSocket('ws://localhost:42069/websocket');
					break;
				} catch (ex) {
					setError('Could not connect to T.I.T.S.: ' + ex);
					await new Promise((r) => setTimeout(r, 5000));
				}
			}
			socket.onopen = () => {
				setConnected(true);
				onOpen?.();
			};
			socket.onmessage = (evt) => {};
			
			let reconnecting = false;
			const reconnect =  async (err) => {
				setConnected(false);
				setError('Could not connect to T.I.T.S.');

				// Reconnect every 5 seconds
				// Wait 5 seconds before reconnecting
				await new Promise((r) => setTimeout(r, 5000));
				if (shouldConnect && !reconnecting) {
					reconnecting = true;
					initWebsocket();
				}
			};
			socket.onclose = reconnect;
			socket.onerror = reconnect;
		};
		initWebsocket();
		return () => {
			shouldConnect = false;
			socket?.close();
		};
	}, [onOpen]);

	return {
		connected,
		error,
	};
};
